//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import {phoneReg} from '@/utils/regular.js'
export default {
    data(){
        return {
           applicantPhone:'',
        }
    },
    props: {
        verify:{ // 是否验证失败
            type: Boolean,
            default() { return false; }
        },
        placeholder:{ // placeholder 文字
            type: String,
            default() { return ''; }
        },
        cookiePhone:{
            type: String,
            default() { return ''; }
        },
        com_id:{ // 组件唯一id，同一页面多次引用此组件时进行区分
            type: String,
            default:'inputPhone'
        },
    },
    watch:{
        applicantPhone(val){
            // if(!this.cookiePhone){
            val = val.trim();
            let phoneFlag ;
            if(new RegExp("[*]").test(val)){
                phoneFlag = true
            }else{
                phoneFlag = phoneReg.test(val)
            }
            this.$emit('phoneEmit',{
                phone:val,
                phoneFlag:phoneFlag
            })
            // }
            
        },
        verify(val){
           this.verify = val
        }
    },
    created() {
        this.applicantPhone =  this.cookiePhone;
        this.bus.$on("phoneInputFlag", (msg)=> {
            this.applicantPhone = msg
        });
        
    },
    methods:{
        cleanInfo(){
            this.applicantPhone = '' 
        },
        scrollInto(){
            
            window.setTimeout(function () {
                const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop ;
                if(scrollHeight){
                    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                }
                //console.log(Math.max(scrollHeight - 1, 0))
            }, 0);
            this.$emit('onBlur',{
                inputText:this.applicantPhone,
                message:this.com_id
                
            })
            
        }
    }
}
